<template>
  <v-row
    justify="center"
  >
    <v-dialog
      v-model="codeConfirmationDialog"
      persistent
      max-width="500"
    >
      <v-card>
        <v-card-title class="headline text-black">
          Confirm Code
        </v-card-title>
        <v-form @submit.prevent="confirm">
          <v-card-text>
            <v-row>
              <v-col>
                <v-alert
                  v-model="invalid"
                  type="error"
                >
                  {{ error }}
                </v-alert>
              </v-col>
            </v-row>
            <v-text-field
              v-model="code"
              label="Code"
              persistent-hint
              :hint="body"
              :error-messages="codeErrors"
              autocomplete="off"
              variant="underlined"
              @blur="v$.code.$touch()"
            />
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              text
              rounded
              @click="closeAndDisagree()"
            >
              Cancel
            </v-btn>
            <v-btn
              color="light-blue-darken-2"
              text
              rounded
              type="submit"
              :loading="loading"
            >
              Submit
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { mapMutations, mapState } from 'vuex'
import { useVuelidate } from '@vuelidate/core'
import httpException from '../mixins/http-exception'

export default {
  name: 'AppCodeConfirmationDialog',
  mixins: [ httpException ],
  setup: () => ({ v$: useVuelidate() }),
  data () {
    return {
      code: '',
      error: '',
      loading: false,
      invalid: false
    }
  },
  computed: {
    ...mapState('dialog', [
      'action',
      'body',
      'codeConfirmationDialog',
      'id'
    ]),

    /**
     * Display the errors of the code.
     *
     */
    codeErrors () {
      const errors = []

      if (!this.v$.code.$dirty) return errors

      this.v$.code.required.$response || errors.push('Code is required.')

      return errors
    }
  },
  methods: {
    ...mapMutations('dialog', ['closeDialog']),

    /**
     * Hides the dialog and executes the action callback function.
     *
     */
    async confirm () {
      this.v$.$touch()

      if (!this.v$.$invalid) {
        this.loading = true

        const config = {
          headers: {
            id: this.id,
            code: this.code
          }
        }

        await this.action(config)
          .then(() => {
            this.reset()
            this.closeDialog('codeConfirmationDialog')
          })
          .catch(({ response }) => {
            this.invalid = true
            this.error = response.data.message
          })

        this.loading = false
      }
    },

    /**
     * Hides the dialog and executes the cancel callback function.
     *
     */
    closeAndDisagree () {
      this.reset()
      this.closeDialog('codeConfirmationDialog')
      if (this.cancel) this.cancel()
    },

    /**
     * Reset the form.
     *
     */
    reset () {
      this.v$.$reset()
      this.code = null
      this.error = ''
      this.loading = false
      this.invalid = false
    }
  },
  validations () {
    return {
      code: { required }
    }
  }
}
</script>
